
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    textAlign: 'right',

    "& label": {
      transformOrigin: "top right",
      right: 0,
      left: "auto"
    }
  },
  paper: {
    padding: theme.spacing(2),
  },
  rtl:{
    direction: "rtl",

  },
  helperText: {
    textAlign: 'right',
    direction: "rtl",

    marginRight: 0

  },
  form: {
    textAlign: 'right',

    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  helperFile:{
    color: 'rgba(0, 0, 0, 0.54)',
    margin: '0',
    fontsize: '0.75rem',
  },
  buttonSubmit: {
    marginBottom: 10,
  },
}));
